"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorRdfResolveQuadPatternStringSource = void 0;
const bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");
const context_entries_1 = require("@comunica/context-entries");
const rdf_store_stream_1 = require("rdf-store-stream");
const readable_stream_1 = require("readable-stream");
/**
 * A comunica RDF Resolve Quad Pattern String Source RDF Resolve Quad Pattern Actor.
 */
class ActorRdfResolveQuadPatternStringSource extends bus_rdf_resolve_quad_pattern_1.ActorRdfResolveQuadPattern {
    constructor(args) {
        super(args);
    }
    async test(action) {
        const source = (0, bus_rdf_resolve_quad_pattern_1.getContextSource)(action.context);
        if (!source) {
            throw new Error(`Actor ${this.name} can only resolve quad pattern queries against a source.`);
        }
        if (!this.isStringSource(source.valueOf())) {
            throw new Error(`Actor ${this.name} can only resolve stringSource quad pattern`);
        }
        return true;
    }
    async run(action) {
        const source = (0, bus_rdf_resolve_quad_pattern_1.getContextSource)(action.context);
        const textStream = new readable_stream_1.Readable({ objectMode: true });
        /* istanbul ignore next */
        textStream._read = () => {
            // Do nothing
        };
        textStream.push(source.value);
        textStream.push(null);
        const parserResult = await this.mediatorRdfParse.mediate({
            context: action.context,
            handle: {
                metadata: { baseIRI: source.baseIRI },
                data: textStream,
                context: action.context,
            },
            handleMediaType: source.mediaType,
        });
        const resolveQuadAction = {
            pattern: action.pattern,
            context: action.context.set(context_entries_1.KeysRdfResolveQuadPattern.source, {
                value: await (0, rdf_store_stream_1.storeStream)(parserResult.handle.data),
                type: 'rdfjsSource',
            }),
        };
        return this.mediatorRdfResolveQuadPattern.mediate(resolveQuadAction);
    }
    isStringSource(datasource) {
        if (!('type' in datasource)) {
            if (!(typeof datasource.value === 'string')) {
                return false;
            }
            return 'mediaType' in datasource;
        }
        return datasource.type === ActorRdfResolveQuadPatternStringSource.sourceType;
    }
}
exports.ActorRdfResolveQuadPatternStringSource = ActorRdfResolveQuadPatternStringSource;
ActorRdfResolveQuadPatternStringSource.sourceType = 'stringSource';
//# sourceMappingURL=ActorRdfResolveQuadPatternStringSource.js.map